import { render, staticRenderFns } from "./RepairsOrdersList.vue?vue&type=template&id=27dc268c&scoped=true&"
import script from "./RepairsOrdersList.vue?vue&type=script&lang=js&"
export * from "./RepairsOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./RepairsOrdersList.vue?vue&type=style&index=0&id=27dc268c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc268c",
  null
  
)

export default component.exports